/**
 * =========================================================================================
 *     Copyright © 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *     File            :   accountRefusal.ts
 *     Description     :   The refusal of an archived person, from any API call: 401 ACCOUNT_ARCHIVED. It lands
 *                         in the auth store, which AuthProvider renders from, so the person is told why instead
 *                         of being retried or signed out. A 401 with any other code is not this.
 *     Author          :   Peter Dobler
 * =========================================================================================
 */
import { ErrorCodes } from '@shared/types/errors';
import { useAuthStore } from '../stores/authStore';

/** Apply an archived refusal to the store. Returns true when the error was one (the caller then stops). */
export function applyAccountRefusal(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { error?: { code?: unknown } } } })?.response;
  if (response?.status !== 401 || response.data?.error?.code !== ErrorCodes.ACCOUNT_ARCHIVED) return false;
  useAuthStore.getState().accountArchivedRefused();
  return true;
}
